import React, { FC } from 'react';

import { DropDownArrow } from '@wix/wix-ui-icons-common/system';

import { DATA_HOOK, SIZE } from './InputShell.constants';
import { st, classes } from './InputShell.st.css';
import Box from '../Box';
import { useIcons } from '../WixDesignSystemIconThemeProvider';

import type { InputShellProps } from './InputShell.types';

/** A wrapper component that has a style of an input component */
const InputShell: FC<InputShellProps> = props => {
  const icons = useIcons('InputShell', {
    DropDownArrow,
  });

  const {
    as: Component = 'div',
    children,
    menuArrow,
    dataHook,
    focused = 'auto',
    onClick,
    placeholder,
    size = SIZE.medium,
    ...rest
  } = props;
  const shouldApplyPlaceholderClass = !children && !!placeholder;

  return (
    <Component
      {...rest}
      data-hook={dataHook}
      className={st(classes.root, {
        menuArrow: props.menuArrow,
        disabled: props.as === 'button' ? props.disabled : false,
        focused: String(focused),
        size,
        placeholder: shouldApplyPlaceholderClass,
      })}
      onClick={onClick as React.MouseEventHandler<HTMLElement>}
    >
      <div className={st(classes.content)}>
        {children ? (
          children
        ) : (
          <div
            data-hook={DATA_HOOK.placeholder}
            className={st({ placeholder })}
          >
            {placeholder}
          </div>
        )}
        {menuArrow && (
          <Box dataHook={DATA_HOOK.menuArrow} className={st(classes.suffix)}>
            <icons.DropDownArrow />
          </Box>
        )}
      </div>
    </Component>
  );
};

InputShell.displayName = 'InputShell';

export default InputShell;
